export class MobilePDFVM {
  MobilePDFBase64: string;
  FileName: string;
}
